<span class="badge"
  [ngClass]="type"
  [attr.data-testid]="'vi-badge-' + type">
  <ng-content></ng-content>
</span>